export default {
  methods: {
    exportToXledger (ids, emailIds, action) {
      if (action === 1) {
        this.invoiceObj.loading = true
        this.$_executeApi('post', 'invoices/export_for_xledger', { ids }).then(response => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.exportedSuccess') })
          this.invoiceObj.selection = []
          window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${response.data}`, '_blank')
          this.invoiceObj.selection = []
          this.getListHandler()
        }).finally(() => {
          this.invoiceObj.loading = false
        })
      } else {
        let model = { invoiceids: ids, to: emailIds }
        this.$_executeApi('post', 'invoices/share_export_for_xledger', model)
          .then(response => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.exportedSuccess') })
            this.invoiceObj.selection = []
            this.getListHandler()
          }).finally(() => {
            this.$eventBus.$emit('closeExportMailDialog')
          })
      }
    }
  }
}
